import React from 'react'

import { Portlet, Button } from '_zari/core'
import { useHistory } from 'react-router-dom'
import * as CodigosTransaccionesConstant from 'constants/codigosTransacciones'
import ResumenVentas from 'partials/resumenVenta'

const VerDetallesPage = ({ match }) => {
  const portletBreadcrumbs = [{ name: 'Ver Detalles' }]

  const history = useHistory()

  const clickCerrarHandle = React.useCallback(() => {
    history.push(`/${CodigosTransaccionesConstant.CONSULTAVENTAS_LISTA}`)
  }, [history])

  return (
    <Portlet>
      <Portlet.Header title='CONSULTA VENTAS' breadcrumbs={portletBreadcrumbs} />
      <Portlet.Body>
        <ResumenVentas id={match.params.id} tipo='portlet'></ResumenVentas>
      </Portlet.Body>
      <Portlet.Footer>
        <Button onClick={() => clickCerrarHandle()}>Cerrar</Button>
      </Portlet.Footer>
    </Portlet>
  )
}

export default VerDetallesPage
